import { api } from './api';

/**
 * Tipo contatto della rubrica (classificatore gestibile dall'utente)
 */
export interface TipoContatto {
  id: number;
  codice: string;
  nome: string;
  descrizione?: string;
  colore?: string;
  ordinamento?: number;
  isActive: boolean;
  numeroContatti?: number;
  createdAt?: string;
  updatedAt?: string;
}

export interface TipoContattoRequest {
  codice?: string;
  nome: string;
  descrizione?: string;
  colore?: string;
  ordinamento?: number;
  isActive?: boolean;
}

const getTipiContatto = async (onlyActive = false): Promise<TipoContatto[]> => {
  const url = onlyActive ? '/tipi-contatto?onlyActive=true' : '/tipi-contatto';
  const response = await api.get<TipoContatto[]>(url);
  return response.data;
};

const getTipoContattoById = async (id: number): Promise<TipoContatto> => {
  const response = await api.get<TipoContatto>(`/tipi-contatto/${id}`);
  return response.data;
};

const createTipoContatto = async (data: TipoContattoRequest): Promise<TipoContatto> => {
  const response = await api.post<TipoContatto>('/tipi-contatto', data);
  return response.data;
};

const updateTipoContatto = async (id: number, data: TipoContattoRequest): Promise<TipoContatto> => {
  const response = await api.put<TipoContatto>(`/tipi-contatto/${id}`, data);
  return response.data;
};

const deleteTipoContatto = async (id: number): Promise<void> => {
  await api.delete(`/tipi-contatto/${id}`);
};

const tipiContattoService = {
  getTipiContatto,
  getTipoContattoById,
  createTipoContatto,
  updateTipoContatto,
  deleteTipoContatto,
};

export default tipiContattoService;
